import promise from 'promise';

import DispatchConstants from 'app/shared/constants/DispatchConstants';
import api from 'app/shared/utils/api';

// service
import appLogger from 'app/shared/loggers/appLogger';

const AbTestingActions = {
    // for experimental ab test
    getExperimentVersionList(tests) {
        const params = {
            tests,
        };

        return (dispatch, getState) => dispatch(api.users.abTest.enroll(params))
            .then((result = {}) => {
                const { error: errorRMWModel, success } = result;

                if (success === false) {
                    return promise.reject(errorRMWModel);
                }

                dispatch({
                    type: DispatchConstants.ENROLL_AB_TEST_EXPERIMENT,
                    payload: result.response.experimentDtos,
                });

                return result.response.experimentDtos;
            })
            .catch((errorRMWModel) => {
                // update message to most likely error
                if (errorRMWModel.message === 'param error') {
                    errorRMWModel.message = `experiment tests not found: ${tests}`;
                }

                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'AbTestingActions.enrollInExperiment',
                    user: getState().user,
                });

                return promise.reject(errorRMWModel);
            });
    },
};

export default AbTestingActions;
